import { i18n } from '@/plugins/i18n';
import { store } from '@/store';
import { UserState } from '@/store/user';
import * as PleasedApi from '@/common/api/api.pleased';
import { Country } from '@/common/config';
import { logger } from '@/common/api/logger';

const ENABLE_CHECKS = true;

interface ApiCheck {
  id: string;
  slots: () => {
    message: string;
    actionMessage: string;
    warning: string;
    commonWarning: string;
  };
  check: () => Promise<boolean>;
}
const KYC: ApiCheck = {
  id: 'KYC',
  slots: () => ({
    message: i18n.t('chat.v2.check.kyc.message') as string,
    actionMessage: i18n.t('chat.v2.check.kyc.action_message') as string,
    warning: i18n.t('chat.v2.check.kyc.warning') as string,
    commonWarning: i18n.t('chat.v2.check.kyc.common_warning') as string,
  }),
  check: async () => {
    if (!ENABLE_CHECKS) return true;

    // TODO: Find a better way to inject user data.
    const vuexState = store.state as { user: UserState };

    if (!vuexState.user.country) {
      logger.error('[KYC] KYC check skipped. User country not available.');
      return true;
    }
    const canUseNewJweAuth = !!vuexState.user.supportJweToken;
    // Check KYC enabled brands.
    if (!([Country.INT, Country.NG, Country.GH, Country.UG] as string[]).includes(vuexState.user.country)) {
      // if this is not one of those countries, the check is not required.
      // This is ideally not required as only brands having KYC should configure this.
      return true;
    }

    return PleasedApi.checkKycCompleted({
      countryCode: vuexState.user.country,
      sportyToken: canUseNewJweAuth ? null : vuexState.user.token,
    }).catch(() => true);
  },
};

export const CHECKS = {
  KYC,
};
